// Time formatting utilities for the universal app

export const formatTime = (time, format = '12') => {
  if (!time) return '';
  
  const [hours, minutes] = time.split(':');
  const hour = parseInt(hours, 10);
  const min = parseInt(minutes, 10);
  
  if (format === '12') {
    const period = hour >= 12 ? 'PM' : 'AM';
    const displayHour = hour === 0 ? 12 : hour > 12 ? hour - 12 : hour;
    return `${displayHour}:${min.toString().padStart(2, '0')} ${period}`;
  }
  
  return `${hour.toString().padStart(2, '0')}:${min.toString().padStart(2, '0')}`;
};

export const convert24To12 = (time24) => {
  if (!time24) return '';
  
  const [hours, minutes] = time24.split(':');
  const hour = parseInt(hours, 10);
  const period = hour >= 12 ? 'PM' : 'AM';
  const displayHour = hour === 0 ? 12 : hour > 12 ? hour - 12 : hour;
  
  return `${displayHour}:${minutes} ${period}`;
};

export const convert12To24 = (time12) => {
  if (!time12) return '';
  
  const [time, period] = time12.split(' ');
  const [hours, minutes] = time.split(':');
  let hour = parseInt(hours, 10);
  
  if (period === 'PM' && hour !== 12) {
    hour += 12;
  } else if (period === 'AM' && hour === 12) {
    hour = 0;
  }
  
  return `${hour.toString().padStart(2, '0')}:${minutes}`;
};

export const getCurrentTime = (format = '24') => {
  const now = new Date();
  const hours = now.getHours();
  const minutes = now.getMinutes();
  
  if (format === '12') {
    return convert24To12(`${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`);
  }
  
  return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`;
};

export const addMinutes = (time, minutesToAdd) => {
  if (!time) return '';
  
  const [hours, minutes] = time.split(':');
  const totalMinutes = parseInt(hours, 10) * 60 + parseInt(minutes, 10) + minutesToAdd;
  
  const newHours = Math.floor(totalMinutes / 60) % 24;
  const newMinutes = totalMinutes % 60;
  
  return `${newHours.toString().padStart(2, '0')}:${newMinutes.toString().padStart(2, '0')}`;
};

export const getTimeDifference = (startTime, endTime) => {
  if (!startTime || !endTime) return 0;
  
  const [startHours, startMinutes] = startTime.split(':');
  const [endHours, endMinutes] = endTime.split(':');
  
  const startTotalMinutes = parseInt(startHours, 10) * 60 + parseInt(startMinutes, 10);
  const endTotalMinutes = parseInt(endHours, 10) * 60 + parseInt(endMinutes, 10);
  
  return endTotalMinutes - startTotalMinutes;
};